import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue";
import VolumeProgress from "./progress.vue";
export default defineComponent({
  name: "VolumeAdjuster",
  components: {
    "volume-progress": VolumeProgress
  },
  props: {
    /** 初始音量 */
    volume: {
      type: Number,
      default: 60
    }
  },
  emits: ["change-volume"],
  setup: function setup(prop, _ref) {
    var emit = _ref.emit;
    var visible = ref(false);

    var onChangeProgress = function onChangeProgress(progress) {
      emit("change-volume", progress / 100);
    };

    var showPopover = function showPopover() {
      visible.value = true;
    };

    var hidePopover = function hidePopover() {
      visible.value = false;
    };

    return {
      visible: visible,
      onChangeProgress: onChangeProgress,
      showPopover: showPopover,
      hidePopover: hidePopover
    };
  }
});